import { functionUtils } from 'utils/func.js';
import GuidelineIframePopup from './popup';

const GuidelineIframeModal = ({
  isShow,
  modalOptions,
  actionClose,
  action,
}) => {
  const isBackdropOverlap = !modalOptions?.isFullScreenWithHeader;

  const handleOnClick = () => {
    if (functionUtils.isFunction(action)) {
      action();
    }
  };

  const handleOnClose = () => {
    if (functionUtils.isFunction(actionClose)) {
      actionClose();
    }
  };

  return (
    <GuidelineIframePopup
      isOpen={isShow}
      modalStyles={{
        width: '866',
        borderRadius: 12,
      }}
      modalOptions={modalOptions}
      onClose={handleOnClose}
      onClick={handleOnClick}
      isBackdropOverlap={isBackdropOverlap}
      zIndexBackdropOverlap={1202}
      zIndexModal={1203}
    />
  );
};

export default GuidelineIframeModal;
